export default "__VITE_ASSET__CigdXwfd__"